import React from 'react';
import { cn } from '../../lib/utils';
import { Card, CardContent } from '../ui/card';

/**
 * KPI / summary metric card — used on dashboards and list headers.
 */
export default function StatCard({
  title,
  value,
  icon: Icon,
  iconClassName = 'text-brand-500 bg-brand-50 dark:bg-brand-500/10',
  onClick,
  loading = false,
  className,
  'data-testid': dataTestId,
}) {
  const clickable = Boolean(onClick);
  return (
    <Card
      interactive={clickable}
      role={clickable ? 'link' : undefined}
      tabIndex={clickable ? 0 : undefined}
      onClick={onClick}
      onKeyDown={(e) => {
        if (!clickable) return;
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          onClick?.();
        }
      }}
      className={cn(clickable && 'cursor-pointer', className)}
      data-testid={dataTestId}
    >
      <CardContent className="p-5">
        <div className="flex items-start justify-between gap-3">
          <div className="min-w-0">
            <p className="text-[11px] font-medium uppercase tracking-[0.12em] text-muted-foreground">
              {title}
            </p>
            <p className="mt-2 font-heading text-metric text-foreground tabular-nums">
              {loading ? '—' : typeof value === 'number' ? value.toLocaleString() : value}
            </p>
          </div>
          {Icon ? (
            <div className={cn('oc-icon-well', iconClassName)}>
              <Icon weight="fill" className="h-5 w-5" />
            </div>
          ) : null}
        </div>
      </CardContent>
    </Card>
  );
}
